// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2bzwm","title":"AfterFrontImage_title__1Qg3g"};